<ng-container *transloco="let convert;">
  <div class="panel card banner-card" [ngClass]="{errorBanner: bannerConfig.mode === 'error'}">
    <div class="banner-card_inner" [class.w-100]="bannerConfig.mode === 'none'">
      @if (bannerConfig.showIcon) {
        @if (bannerConfig.showSuccessIcon) {
          <em class="allycon-success-fill text-success me-2" alt="success-icon"></em>
        }
        @if (bannerConfig.showErrorIcon) {
          <em class="allycon-error-fill text-destructive me-2" alt="error-icon"></em>
        }
      }

      <p class="mb-0" [class.center]="bannerConfig.mode === 'none'" [innerHTML]="bannerConfig.text">
        @if (bannerConfig.showUndo) {
          <a
            href="#"
            class="text-bold"
            (click)="undoRemove($event)"
            data-track-elem="button"
            data-track-name="Undo?"
            >{{convert('common.btnUndo')}}</a
            >
          }
        </p>
      </div>
      <button
        class="modal__close"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="close.emit()"
        data-track-elem="icon"
        data-track-name="Close"
        >
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </ng-container>
